import { useTranslation } from "react-i18next";

import { ORG_UNIT_ACCENT } from "@/components/agents/configuration-server/orgUnitAccent";

/**
 * Legenda das cores da árvore, fechando o bloco de filtros (a divisória do
 * bloco vem depois dela). Procedência é amarelo da marca para o que veio do
 * ERP e azul-escuro para o que o consultor criou — faixa lateral na lista,
 * sombra no card; cadastro no CBC é a cor do FUNDO. Eixos separados de
 * propósito: uma unidade manual já cadastrada precisa mostrar as duas coisas.
 */
export function OrgOriginLegend() {
  const { t } = useTranslation();
  const items = [
    { label: "Extracted from ERP", swatch: ORG_UNIT_ACCENT.sap.swatch },
    { label: "Created manually", swatch: ORG_UNIT_ACCENT.manual.swatch },
    { label: "Registered in CBC", swatch: ORG_UNIT_ACCENT.registeredSwatch },
  ];

  return (
    <ul
      aria-label={t("Legend")}
      className="flex flex-wrap items-center gap-x-4 gap-y-1 border-b border-[#f2f4f7] px-4 pb-3 text-[11px] text-[#596b85]"
    >
      {items.map((item) => (
        <li key={item.label} className="flex items-center gap-1.5">
          <span aria-hidden className={`inline-block h-3 w-3 rounded-sm ${item.swatch}`} />
          {t(item.label)}
        </li>
      ))}
    </ul>
  );
}
